class OacListMapValueConverter {
  toView(list, fn) {
    return list.map(fn);
  }
}

export { OacListMapValueConverter };
